import { sessionDataHandler } from "../../sessionDataHandler";
import { changeEngagementPhase, glanceReset, updatePreEngagementData } from "./genericActions";
import { AppState, EngagementPhase } from "../definitions";
import { autoInitSession } from "./initActions";
import { AnyDispatch } from "./listeners/definitions";

export function startNewChat() {
    return async (dispatch: AnyDispatch, getState: () => AppState) => {
        const {
            config: { autoInitConfig, glance }
        } = getState();
        sessionDataHandler.clear();

        dispatch(glanceReset());

        if (autoInitConfig === undefined) {
            dispatch(updatePreEngagementData({ email: "", name: "", query: "", fields: undefined }));
            dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
        } else {
            const { name, email, query, ...preInitData } = autoInitConfig;
            dispatch(
                autoInitSession({
                    name,
                    email,
                    query,
                    data: preInitData,
                    glanceConfiguration: glance
                })
            );
        }
    };
}
